import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';

import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import FormHelperText from '@material-ui/core/FormHelperText';


import { useStyles } from './UserTheme';

export default function UserSettingPackage() {
  const classes = useStyles();

  return <Grid container direction="row" className={classes.root}>
    <Grid item className={classes.formContanier}>
      <Typography align="center" variant="h6" gutterBottom>
        Csomagok
        </Typography>
      <Divider />
      <form className={classes.form}>
        <FormControl component="fieldset" className={classes.formControl}>
          <FormGroup>
            <FormControlLabel
              control={<Checkbox checked={true} name="alap" />}
              label="Alap"
            />
            <FormControlLabel
              control={<Checkbox checked={true} name="kozep" />}
              label="Közép"
            />
            <FormControlLabel
              control={<Checkbox checked={true} name="nagy" />}
              label="Nagy"
            />
          </FormGroup>
          <FormHelperText></FormHelperText>
        </FormControl>
        <div className={classes.button}>
          <Button
            variant="contained"
            color="primary"
            fullWidth
          >
            Megrendel
          </Button>
        </div>
      </form>

    </Grid>
    <Grid item xs>
      <Grid container className={classes.grund}>

      </Grid>
    </Grid>

  </Grid >;
}